/**
 * CommunityVideoPlayer
 *
 * Thin owner wrapper over the shared NativeVideoPlayer: binds the always-signed
 * token fetch to /api/communities/:communityId/videos/:videoId/playback-token.
 * All the playback/retry/remount logic lives in NativeVideoPlayer.
 */

import { useCallback } from "react"
import { NativeVideoPlayer } from "@/components/media/NativeVideoPlayer"
import {
  type CommunityVideoItem,
  getCommunityVideoPlaybackToken,
} from "../services/communityVideo.service"

export interface CommunityVideoPlayerProps {
  communityId: string
  video: CommunityVideoItem
  /** Lazy-mint: only the active carousel slide mints a token. Defaults to true. */
  active?: boolean
  className?: string
}

export function CommunityVideoPlayer({
  communityId,
  video,
  active,
  className,
}: CommunityVideoPlayerProps) {
  const fetchToken = useCallback(
    () => getCommunityVideoPlaybackToken(communityId, video.id),
    [communityId, video.id],
  )
  return (
    <NativeVideoPlayer
      status={video.status}
      cloudflareUid={video.cloudflareUid}
      failureReason={video.failureReason}
      fetchToken={fetchToken}
      active={active}
      className={className}
    />
  )
}
